import React from 'react'
import { useState } from '@hookstate/core'
import { Col, Row } from 'react-bootstrap'
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState'
import { useLanguageState } from '../../globalStates/LanguageState'
import { getElementFieldValue, makeSetHandler } from '../../globalStates/utils'
import Section from '../../components/Section'
import TextSocial from '../../components/Field/TextSocial'
import FacebookIcon from '../../images/facebook.svg'
import InstagramIcon from '../../images/instagram.svg'
import LinkedinIcon from '../../images/linkedin.svg'
import XingIcon from '../../images/xing.svg'
import TwitterIcon from '../../images/twitter.svg'
import YoutubeIcon from '../../images/youtube.svg'
import PinterestIcon from '../../images/pinterest.svg'

const SocialMediaSection: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const organizationState = useExhibitorDataState().getOrganization()
    const organization = useState(organizationState)
    return (
        <Section title={branding.configuration.profilePage.sctSocialMedia.lblSocialMedia}>
            <Row>
                <Col>
                    <TextSocial
                        name="facebook"
                        label={branding.configuration.profilePage.sctSocialMedia.lblFacebook}
                        icon={FacebookIcon}
                        value={getElementFieldValue(organization, "facebook")}
                        onChange={makeSetHandler(organization, 'facebook')}
                    />
                </Col>
                <Col>
                    <TextSocial
                        name="instagram"
                        label={branding.configuration.profilePage.sctSocialMedia.lblInstagram}
                        icon={InstagramIcon}
                        value={getElementFieldValue(organization, "instagram")}
                        onChange={makeSetHandler(organization, 'instagram')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TextSocial
                        name="linkedIn"
                        label={branding.configuration.profilePage.sctSocialMedia.lblLinkedIn}
                        icon={LinkedinIcon}
                        value={getElementFieldValue(organization, "linkedIn")}
                        onChange={makeSetHandler(organization, 'linkedIn')}
                    />
                </Col>
                <Col>
                    <TextSocial
                        name="xing"
                        label={branding.configuration.profilePage.sctSocialMedia.lblXing}
                        icon={XingIcon}
                        value={getElementFieldValue(organization, "xing")}
                        onChange={makeSetHandler(organization, 'xing')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TextSocial
                        name="twitter"
                        label={branding.configuration.profilePage.sctSocialMedia.lblTwitter}
                        icon={TwitterIcon}
                        value={getElementFieldValue(organization, "twitter")}
                        onChange={makeSetHandler(organization, 'twitter')}
                    />
                </Col>
                <Col>
                    <TextSocial
                        name="youTube"
                        label={branding.configuration.profilePage.sctSocialMedia.lblYouTube}
                        icon={YoutubeIcon}
                        value={getElementFieldValue(organization, "youTube")}
                        onChange={makeSetHandler(organization, 'youTube')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TextSocial
                        name="pinterest"
                        label={branding.configuration.profilePage.sctSocialMedia.lblPinterest}
                        icon={PinterestIcon}
                        value={getElementFieldValue(organization, "pinterest")}
                        onChange={makeSetHandler(organization, 'pinterest')}
                    />
                </Col>
                <Col>&nbsp;</Col>
            </Row>
        </Section>
    );
}
export default SocialMediaSection
